<template>
  <div class="header">
    <div class="col-xs-12 text-center">
      <div class="negotiation-status">
        <slot name="status"></slot>
      </div>
    </div>

    <div class="row">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "s-header",
  }
</script>
